<div class="container">

    <h1>Gizlilik İlkesi</h1>
    <h3>TV264 İnternet Gizlilik Politikası</h3>
    <p>TV264 bilgilerinizin gizliliğine saygı duymaktadır. Bu politika bize ilettiğiniz kişisel bilgilerinizi ve bu
        bilgileri nasıl kullanabileceğimizi özetlemektedir. Bu politika ayrıca, gizliliğiniz ile ilgili diğer önemli
        konuları da açıklamaktadır.</p>

    <h3>İçindekiler</h3>
    <p>TV264 İnternet Gizlilik Politikası ,Muvafakatınız ,Kişisel bilgilerin toplanması, kullanılması ve açıklanması
        hakkında sınırlamalar ,TV264 Yazılım internet sitesi üzerinden toplanan bilgiler ve bu bilgilerin nasıl
        kullanılabileceği ,Kişisel bilgilerin paylaşımı, Kişisel bilgilerin güvenli-ği ,Kişisel bilgilerin alıkonulması
        ,Çocuklar ve ebeveynler ,Bu politika ya da gizlilik beyanları hakkında sorular ,Bu politika ve gizlilik
        beyanlarımızdaki değişiklikler</p>


    <h3>Muvafakatınız</h3>
    <p>TV264 internet sitesini kullanarak ya da bize kişisel bilgiler sağlayarak, kişisel bilgilerinizin bu politikada
        ve uygulanacak olan her tür ülke ya da web sitesi gizlilik beyanında açıklandığı gibi toplanmasına,
        kullanılmasına ve açıklanmasına muvafakat etmektesiniz.</p>

    <h3>Kişisel bilgilerin toplanması, kullanılması ve açıklanması hakkında sınırlamalar</h3>
    <p>Uygulanacak kanun tarafından talep edildiği derecede, TV264 internet sitesinden her ne zaman kişisel bilgi
        toplarsa; Kendisinin veri uygulamalarından sizi zamanında ve uygun bir biçimde haberdar edecektir. Açık ya da
        gizli olabilecek olan muvafakatiniz ile kişisel bilgilerinizi kişisel bilginin hassaslığı, yasal şartlar ve
        diğer faktörlere bağlı olarak toplayacak, kullanacak ve iletecektir. Kişisel bilgilerinizi sadece özel, sınırlı
        amaçlar içerisinde toplayacaktır. Topladığımız bilgiler, toplanma amacı doğrultusunda ilgili, yeterli ve
        abartısız olacaktır. Kişisel bilgilerinizi asıl olarak toplanma ya da sizin bilahare muvafakat ettiğiniz amaç
        ile tutarlı biçimde işleyecektir. Kişisel bilgilerinizin amaçlanan kullanımı açısından güvenilir, gerçek, tam ve
        gerekli olduğunda güncel olmasını sağlamak için makul adımları atacaktır. Size “vazgeçme” fırsatı vermeden
        kişisel bilgilerinizi doğrudan pazarlama amacıyla kullanmayacaktır. Üçüncü bir kişiye açıklanan ya da diğer bir
        ülkeye iletilen kişisel bilgilerin sözleşme yoluyla ya da başka bir biçimde, TV264 içerisindeki iletimler dahil,
        yeterli bir biçimde korunmasını sağlamak için uygun tedbirleri alacaktır.</p>

    <h3>TV264 internet sitesi üzerinden toplanan bilgiler ve bu bilgilerin nasıl kullanılabileceği</h3>
    <p>TV264 internet sitesini kullandığınızda sizin hakkınızda bilgi toplayabiliriz:</p>

    <h3>TV264 İnternet Gizlilik Politikası</h3>
    <p>TV264 bilgilerinizin gizliliğine saygı duymaktadır. Bu politika bize ilettiğiniz kişisel bilgilerinizi ve bu
        bilgileri nasıl kullanabileceğimizi özetlemektedir. Bu politika ayrıca, gizliliğiniz ile ilgili diğer önemli
        konuları da açıklamaktadır.</p>

    <h4>1. Web tarayıcınız tarafından bize gönderilen bilgiler</h4>
    <p>TV264, bize web tarayıcınız tarafından otomatik olarak gönderilen bilgileri toplamaktadır. Bu bilgiler tipik
        olarak sizin internet servis sunucunuzun IP adresi, işletim sisteminizin ismi (Macintosh® ya da Windows® gibi)
        ve web tarayıcınızın versiyonunu (İnternet Explorer® ya da Mozilla® gibi) içermektedir. Lütfen, tarayıcınızın ne
        gibi bilgiler gönderdiğini ya da ayarlarınızı nasıl değiştireceğinizi öğrenmek istemeniz halinde tarayıcınızı
        kontrol edin. Tarayıcınız tarafından sağlanan bilgiler sizi kişisel olarak tanımlamaz. Biz bu bilgileri sitemizi
        geliştirmemize ve onları internet ziyaretçilerimiz tarafından kullanılan teknoloji ile daha uyumlu hale
        getirmemize yardımcı olan istatistikler oluşturmak için kullanmaktayız.</p>


    <h4>Bilgisayarınıza bir “Çerez (Cookie)” yerleştirerek toplanan bilgiler</h4>
    <p>TV264, bilgisayarınızın sabit diskine bir “etiket” yükleyerek hakkınızda bilgi toplayabilir. Bu etiket “çerez”
        olarak bilinmektedir. TV264 internet sitesi “oturum çerezleri” kullanmaktadır. Bir oturum çerezi
        bilgisayarınızı, sitemize giriş yaptığınızda bir bilgisayar tarafından oluşturulan, benzersiz bir tanımlayıcı
        ile etiketlemek için kullanılır. Bir oturum çerezi, sizi kişisel olarak tanımlamaz ve tarayıcınızı kapattıktan
        sonra sona erer. Biz oturum çerezlerini ziyaretçilerimizin sitemizi kullanma yolları – hangi sayfaları ziyaret
        etmekteler, hangi linkleri kullanmaktalar ve her bir sayfada ne kadar süre kalmaktadırlar – hakkında
        istatistiksel bilgi toplamak için kullanmaktayız. Bu (tıklama akışı verileri) bilgileri, ziyaretçilerimizin
        menfaatlerini ve sitemizin içerik ve işlevselliğini iyileştirme gereksinimlerini daha iyi anlayacak biçimde
        istatistiksel olarak analiz etmekteyiz. Çerezleri almayı istememeniz halinde, tarayıcınızı reddetmeye ya da
        bilgisayarınıza bir çerez yerleştirildiğinde uyarmaya ayarlayabilirsiniz. Her ne kadar bir TV264 internet
        sitesini ziyaret ettiğinizde çerezleri kabul etmeniz gerekmese de tarayıcınızın çerezleri reddetmesi halinde,
        sitenin tüm işlevlerini kullanamayabilirsiniz.</p>






    <h4>3. Bilerek ve isteyerek sağladığınız bilgiler</h4>
    <p>TV264 internet sitesini kullandığınızda bilerek ve isteyerek sağladığınız bilgileri toplamaktadır, örneğin;
        e-posta uyarıları almak için kayıt olduğunuzda, bir anketi doldurduğunuzda ya da bize geril bildirim için bir
        soru sorduğunuzda ya da e-posta attığınızda sağladığınız bilgiler. Birçok durumda bu bilgiler kişisel bilgiler
        olacaktır. TV264 bu bilgileri sizin sağlama amacınız için kullanmaktadır. Örneğin; e-posta uyarıları almak için
        kayıt yaptırdığınızda e-posta adresinizi verdiğinizde, e-posta adresinizi talep ettiğiniz e-posta uyarılarını
        göndermek için kullanmaktayız. TV264 internet sitesinden topladığımız bilgileri, müşteri hizmetleri,
        dolandırıcılığı önleme, pazar araştırması, ürünlerimizi ve hizmetlerimizi iyileştirmek ve size ve şirketinize
        ilgi duyabileceğinize inandığımız bilgi ve teklifleri sunmak gibi çeşitli iş amaçları için kullanabiliriz. TV264
        sitesi, kişisel bilgilerinizin kullanımı hakkında seçim yapmanıza olanak tanımaktadır. Birçok durumda,
        seçimlerinizi kişisel bilgilerinizi verdiğiniz zamanda ve sayfada göstermenizi istemekteyiz.</p>




    <h2>Kişisel bilgilerin paylaşımı</h2>
</div>